import TextButton from "@components//buttons/TextButton"
import Review from "@components//Review"
import Stars from "@components//Stars"
import ImageThumbnails from "@components/ImageThumbnails"
import colors from "@constants/colors"
import { h4Styles, smallcapsBold14Styles } from "@constants/typography"
import { getIn } from "@utils/index"
import React from "react"
import styled from "styled-components"

import { ModalBaseProps } from ".."
import { YotpoReview } from "../../../reviews/types"

const Container = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

const Header = styled.div`
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: none;
  margin-bottom: 68px;
  flex-wrap: wrap;
`

const HeaderText = styled.div`
  ${h4Styles}
  margin-right: 24px;
`

const HeaderButton = styled(TextButton)`
  width: 248px;
  margin-left: auto;
`

const RatingsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const Ratings = styled(Stars)`
  margin-right: 24px;
`

const RatingsText = styled.div`
  ${smallcapsBold14Styles}
  color: ${colors.black};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
`

const StyledReview = styled(Review)`
  padding-bottom: 48px;
  border-bottom: 1px solid ${colors.dividerLineGray};
  margin-bottom: 27px;
`

const ImageThumbnailsWrapper = styled.div`
  margin-bottom: 56px;
`

interface DesktopReviewsModalProps extends ModalBaseProps {
  avgRating: number
  numReviews: number
  onClickCount: () => void
  onClickImage: (id) => void
  onClickWriteReview: () => void
  reviewImages: Array<{
    alt: string
    image: string
    onClick?: () => void
    review: number
    thumbnail: string
  }>
  reviews: YotpoReview[]
}

const DesktopReviewsModal = ({
  avgRating,
  numReviews,
  onClickCount,
  onClickImage,
  onClickWriteReview,
  reviewImages,
  reviews,
}: DesktopReviewsModalProps) => (
  <Container>
    <Header>
      <HeaderText>Reviews</HeaderText>
      <RatingsContainer>
        <Ratings stars={Math.round(avgRating)} />
        <RatingsText>{numReviews}</RatingsText>
      </RatingsContainer>
      <HeaderButton
        onClick={() => onClickWriteReview()}
        text="Write a Review"
      />
    </Header>
    {reviewImages.length > 0 && (
      <ImageThumbnailsWrapper>
        <ImageThumbnails
          images={reviewImages}
          imagesToShow={4}
          onClickCount={onClickCount}
        />
      </ImageThumbnailsWrapper>
    )}
    <Content>
      {reviews.map((review) => (
        <StyledReview
          data={review}
          key={getIn(review, "id")}
          onClickImage={onClickImage}
        />
      ))}
    </Content>
  </Container>
)

export default DesktopReviewsModal
